/**
 * Sheet 30 callout 7, second part: the expiry-email note (mission 10 WP18 T107; FR-019, FR-007, FR-022,
 * C-013; spec amendment 21; OR-15, U19; research §1.27 "The retention variants on existing screens").
 *
 * Register 37 `retentionExpiryEmailNote` with `{days}` from `terms.expiry_notice_days`, rendered only when
 * the window is at least `terms.digest_min_window_days`: the digest's own rule, so the page never promises
 * an email the sweep's digest does not send. Both periods are the window read's `terms`, never literals.
 */
import type { RetentionWindow } from '@/lib/api/retention'
import { PROVISIONAL_COPY } from '@/lib/provisional-copy'

export interface RetentionExpiryNoteProps {
  /** The retention read's first page: the window and its terms. */
  retention: Pick<RetentionWindow, 'retention_days' | 'terms'>
}

export function RetentionExpiryNote({ retention }: RetentionExpiryNoteProps) {
  const { retention_days: days, terms } = retention
  if (days < terms.digest_min_window_days) return null
  return (
    <p data-retention-expiry-note="" className="text-body-sm text-navy-600">
      {PROVISIONAL_COPY.retentionExpiryEmailNote.render({ days: terms.expiry_notice_days })}
    </p>
  )
}
